import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import { NavMenuList, NavMenuListSkeleton } from '../components/NavMenuList';
import { useAccountWithGuard } from '../hooks/api/account-with-guard';
import { useAuth } from '../hooks/useAuth';

export function AccountLayout() {
  const nav = useNavigate();
  const { setToken } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const { t } = useTranslation();

  // ensure user logged in
  const { data, isLoading } = useAccountWithGuard();
  const handleLogout = () => {
    setToken('');
    localStorage.removeItem('id_token');
    nav('/login');
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>
        <Box sx={{ width: 240, display: { xs: 'none', lg: 'block' } }}>
          <Typography variant="h5" sx={{ mb: 1, mt: 2 }}>
            {t('navMenuList.myAccountTitle')}
          </Typography>

          {isLoading ? (
            <NavMenuListSkeleton />
          ) : (
            <NavMenuList
              onLogout={handleLogout}
              userPermissions={data?.permissions}
              firstName={data?.individual?.firstName}
              lastName={data?.individual?.lastName}
              employee={data?.employee}
            />
          )}
        </Box>

        <Box
          sx={{
            flex: 1,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
